export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/rawpixel-com-2-9f8458619942c936788dadc7b397be56.jpg";